{
  "es": {
    "select": {
      "actions": {
        "clear": "Limpiar",
        "filterProject": "Filtrar por proyecto",
        "filterUnit": "Filtrar por unidad",
        "noResults": "Sin resultados",
        "noResultsFor": "Sin resultados para {search}",
        "reset": "Restablecer",
        "selectCategory": "Seleccionar categoría",
        "selectUnit": "Seleccionar unidad",
        "setToday": "Hoy",
        "startTyping": "Empieza a escribir para buscar"
      },
      "groups": {
        "customers": "Clientes",
        "employees": "Empleados"
      },
      "labels": {
        "allUnits": "Todas las unidades",
        "contact": "Contacto",
        "without": "Sin",
        "withoutContact": "Sin persona de contacto"
      },
      "placeholders": {
        "contact": "Busca una persona, o elige 'sin'..."
      }
    }
  }
}
